module.exports = __webpack_public_path__ + "static/monikawork1-539dddc9ec0eebd6393ea35663818658.jpg";